function initNavVideos() {   


	var $tree_item = $('.main-nav.homepage-nav .nav-tree .tree-item');
	var $video_el = $tree_item.closest('.main-nav').find('.video-bg-container'); 

	if($('body').hasClass("no-touch")){

		var $video_url = $video_el.data('video');
    	var $image_url = $video_el.data('bg');

    	 if($video_url!=="" ){
        	setBg( $video_el , $video_url , 'video');  
        }else{
        	setBg( $video_el , $image_url , 'image');  
        }
		
		
		$tree_item.mouseenter(function(){
		
	        var $this = $(this);
	        var $video_url = $this.data('video');
	        var $image_url = $this.data('bg');

	        if($video_url!=="" ){
	        	setBg( $video_el , $video_url , 'video');  	        	
	        }else{
	        	setBg( $video_el , $image_url , 'image');    
	        }
	        
	       
	    });	
	    $tree_item.mouseleave(function () {
	    	var $video_url = $video_el.data('video');
	    	var $image_url = $video_el.data('bg');

	        if($video_url!=="" ){
	        	setBg( $video_el , $video_url , 'video');  
	        }else{
	        	setBg( $video_el , $image_url , 'image');  
	        }

	        
	    });		 
	}else if($('body').hasClass("touch")){
		var $image_url = $video_el.data('bg');
		setBg( $video_el , $image_url , 'image');  
	}
  
} 

function initEstateVideos() {   

	var $video_el = $('.video-bg-container'); 

	$video_el.each(function() {
	
		if($('body').hasClass("no-touch")){
			var $video_url = $(this).data('video');
	    	var $image_url = $(this).data('bg');

	    	if($video_url!=="" ){	      
	        	setBg( $(this) , $video_url , 'video');  
	        }else{	        	
	        	setBg( $(this) , $image_url, 'image');  
	        }

		}else if($('body').hasClass("touch")){
			var $image_url = $(this).data('bg');			
			setBg( $(this) , $image_url, 'image');  
		}

	});

    
} 


function initMenuVideos() {   

	var $video_el = $('.menu-video-bg-container'); 

	if($('body').hasClass("no-touch")){

		var $video_url = $video_el.data('video');
    	var $image_url = $video_el.data('bg');

    	 if($video_url!=="" ){
    	 	setBg( $video_el , $video_url, 'video');  
        }else{        	
        	setBg( $video_el , $image_url, 'image');  
        }
		
		
		 
	}else if($('body').hasClass("touch")){
		var $image_url = $video_el.data('bg');		
		setBg( $video_el , $image_url, 'image');  
	}
    
} 

function setBg($video_el , $bg_url, $type ) {    
	try {
		if (typeof $video_el !== "undefined") {
			$video_el.fadeOut('800',function(){
				if($type == 'video'){
					$video_el.html('<video class="video-bg" playsinline autoplay loop muted="muted"><source src="'+$bg_url+'" type="video/mp4"></video>') ;
					$video_el.find('.video-bg').get(0).play();
					$video_el.find('.video-bg').oncanplay = function() {
					    alert("Can start playing video");
					};

				}else{
					$video_el.html('<div class="img-bg" style= background-image:url('+ $bg_url+')></div>') ;
				}				
				$video_el.fadeIn('800');
			}); 	
		}		
	}
	catch(err) {
		console.log(err);
	}	
} 

